import { render, staticRenderFns } from "./modal-select-language.vue?vue&type=template&id=0a66a9aa&scoped=true"
import script from "./modal-select-language.vue?vue&type=script&lang=js"
export * from "./modal-select-language.vue?vue&type=script&lang=js"
import style0 from "./modal-select-language.vue?vue&type=style&index=0&id=0a66a9aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66a9aa",
  null
  
)

export default component.exports